'use strict';

import Component from 'generic.basecomponent';
import Listing from './listing';
import LoadMoreListing from './load-more-listing';
import PaginationListing from './pagination-listing';

export default class GenericListing extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.listing = GenericListing.create(this.container);
        this.listing.init();
    }

    static create(container) {
        let pagination = container.getAttribute('data-pagination');
        if (pagination && pagination === 'pages') {
            return new PaginationListing(container);
        } else {
            return new LoadMoreListing(container);
        }
    }
}

Listing.id = 0;



// WEBPACK FOOTER //
// ./app/components/listing/js/generic.listing.js